'use strict';
var userAgent = require('../internals/environment-user-agent');

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/environment-is-ios-pebble.js
// module id = 661
// module chunks = 13